import './style.less';
import template from './template.html';

export default function() {
  'ngInject';
  return {
    template: template,
    controller: function($scope, $timeout) {
      'ngInject';
      $scope.loadingMsg = [
        'Crunching the numbers...',
        'Grabbing our calculator...',
        'Digging out the file from a cabinet...',
        'Balancing the books...',
        'Organizing our binders...',
        'Sharpening our pencils...',
        'Grabbing our slide rule...',
        'Doing a quick trial balance...',
        'Reconciling some things...',
        'Filling in the GAAPs...',
        'Cooking up some things, not the books...',
        'Arranging our journal entries...'
      ];

      function random() {
        return Math.floor(Math.random() * $scope.loadingMsg.length);
      }
      $scope.number = random();
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/spinnerSm/index.js